module.exports = __webpack_public_path__ + "assets/img/driver-btn-d2e3af16.png";